// src/chatbot/components/LoadingIndicator.tsx
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FaRobot, FaDatabase } from 'react-icons/fa';
import type { Branch } from '~/types/new_types';
import TypingDots from './TypingDots';

interface LoadingIndicatorProps {
	theme: Branch['theme'];
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ theme }) => {
	const { t } = useTranslation();
	const [showExtendedMessage, setShowExtendedMessage] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => {
			setShowExtendedMessage(true);
		}, 5000); // Show extended message after 5 seconds

		return () => clearTimeout(timer);
	}, []);

	const createDotVariants = (delay: number) => ({
		initial: {
			y: 0,
		},
		animate: {
			y: [-4, 4, -4], // Bounce up and down
			transition: {
				duration: 0.6,
				repeat: Infinity,
				ease: "easeInOut",
				delay: delay
			}
		}
	});

	return (
		<motion.div
			initial={{ opacity: 0, y: 20 }}
			animate={{ opacity: 1, y: 0 }}
			className="flex gap-3 justify-start"
		>
			{/* Bot Avatar */}
			<div
				className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mt-1"
				style={{
					backgroundColor: `${theme.primaryColor}15`,
					color: theme.primaryColor
				}}
			>
				<motion.div>
					<FaRobot size={14} />
				</motion.div>
			</div>

			{/* Loading Message */}
			<div className="max-w-[75%]">
				<motion.div
					className=""
					key={showExtendedMessage ? 'extended' : 'initial'}
					initial={{ opacity: 0, y: 5 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.3 }}
				>
					<motion.img
						className='w-8 mt-1 object-cover object-center'
						style={{
							clipPath: 'inset(0)',
							display: 'block'
						}}
						src="/output-onlinegiftools.gif"
						alt="" />
				</motion.div>
			</div>
		</motion.div>
	);
};

export default LoadingIndicator;